import React from 'react';
import ReactDOM from 'react-dom';

import { apps, setCurrentApp } from '../../config';
import '../../assets/stylesheets/fonts.css';
import '../../assets/stylesheets/index.css';
import App from './App';

setCurrentApp(apps.HOME);

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/apps/home/index.js